import { makeZeroArgHook } from "../../utils/makeZeroArgHook";
import getPlanAccountTypes, { planAccountTypesUrl, } from "../requests/getPlanAccountTypesV2";
export const getPlanAccountTypesKeyMaker = () => [
    planAccountTypesUrl(),
];
const useGetPlanAccountTypes = makeZeroArgHook(getPlanAccountTypes, getPlanAccountTypesKeyMaker);
export default useGetPlanAccountTypes;
//# sourceMappingURL=useGetPlanAccountTypesV2.js.map